import { useTranslation } from 'react-i18next';
import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter } from '@/components/ui/alert-dialog';

export const LogoutFailureAlert = ({ open, retrying, onRetry }) => {
  const { t } = useTranslation();
  return (
    <AlertDialog open={open}>
      <AlertDialogContent data-testid="logout-failure-dialog" className="w-[calc(100%_-_2rem)] max-w-md max-h-[90dvh] overflow-y-auto">
        <AlertDialogHeader>
          <AlertDialogTitle data-testid="logout-failure-title">{t('review368.logoutTitle')}</AlertDialogTitle>
          <AlertDialogDescription data-testid="logout-failure-description">{t('review368.logoutBody')}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button data-testid="logout-retry-button" disabled={retrying} onClick={onRetry} className="whitespace-normal h-auto min-h-10">
            <RefreshCw className={`mr-2 h-4 w-4 shrink-0 ${retrying ? 'animate-spin' : ''}`} />
            {t('review368.retry')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};